import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/loginp.vue";
import Home from "../views/Home.vue";
import homePage from "../views/homePage.vue";
import order from "../views/order.vue";
import invoice from "../views/invoice.vue";
import management from "../views/management.vue";
import agreement from "../views/agreement.vue";
import pay from "../views/pay.vue";
import payment from "../views/payment.vue";
import application from "../views/application.vue";
import selfHelp from "../views/selfHelp.vue";
import choice from "../views/choice.vue";
import surrender from "../views/surrender.vue";
import administration from "../views/administration.vue";
import details from "../views/details.vue";
import newhomepage from "../views/newHomePage.vue";
import mobilehome from "../views/mobileHome";
import headPay from "../views/headPay";

Vue.use(VueRouter);

const routesm = [
  {
    path: "/mobilehome",
    name: "mobileHome",
    component: mobilehome,
  },
  {
    path: "/newhomepage",
    name: "newHomePage",
    component: newhomepage,
  },
  {
    path: "/",
    name: "homePage",
    component: () => import("../views/homePage/index.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/selfhelp",
    name: "Selfhelp",
    component: () => import("../views/selfHelp/index.vue"),
  },
  {
    path: "/selectbank",
    name: "Selectbank",
    component: () => import("../views/selfHelp/selectBank.vue"),
  },
  {
    path: "/pay",
    name: "Pay",
    component: () => import("../views/selfHelp/pay.vue"),
  },
  {
    path: "/order",
    name: "Order",
    component: () => import("../views/order/index.vue"),
  },
  {
    path: "/orderData",
    name: "OrderData",
    component: () => import("../views/order/orderData.vue"),
  },
  {
    path: "/refund",
    name: "Refund",
    component: () => import("../views/order/refund.vue"),
  },
  {
    path: "/insurance",
    name: "Insurance",
    component: () => import("../views/order/insurance/index.vue"),
  },
  {
    path: "/invoice",
    name: "Invoice",
    component: () => import("../views/invoice/index.vue"),
  },
  {
    path: "/applyInvoice",
    name: "ApplyInvoice",
    component: () => import("../views/invoice/applyInvoice.vue"),
  },
  {
    path: "/drawBill",
    name: "DrawBill",
    component: () => import("../views/invoice/drawBill.vue"),
  },
  {
    path: "/details",
    name: "Details",
    component: () => import("../views/invoice/details.vue"),
  },
  {
    path: "/user",
    name: "User",
    component: () => import("../views/user/index.vue"),
  },
  {
    path: "/certification",
    name: "Certification",
    component: () => import("../views/user/certification.vue"),
  },
  {
    path: "/changePass",
    name: "ChangePass",
    component: () => import("../views/user/changePass.vue"),
  },
  {
    path: "/performance",
    name: "Performance",
    component: () => import("../views/selfHelp/warrantyInsurance/performance.vue"),
  },
  {
    path: "/advancePayment",
    name: "AdvancePayment",
    component: () => import("../views/selfHelp/warrantyInsurance/advancePayment.vue"),
  },
  {
    path: "/wages",
    name: "Wages",
    component: () => import("../views/selfHelp/warrantyInsurance/wages.vue"),
  },
];
//pc端路由
const routespc = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/payment",
    name: "payment",
    component: payment,
  },
  {
    path: "/newhomepage",
    name: "newHomePage",
    component: newhomepage,
  },
  {
    path: "/headPay",
    name: "headPay",
    component: headPay,
  },
  {
    path: "/presentation",
    name: "presentation",
    component: () => import("../views/presentation.vue"),
  },
  // homePage
  {
    path: "/homePage",
    name: "homePage",
    component: homePage,
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
      },
      {
        path: "/choice",
        name: "choice",
        component: choice,
      },
      {
        path: "/administration",
        name: "administration",
        component: administration,
      },
      {
        path: "/surrender",
        name: "surrender",
        component: surrender,
      },
      {
        path: "/details",
        name: "details",
        component: details,
      },
      {
        path: "/application",
        name: "application",
        component: application,
      },
      {
        path: "/selfHelp",
        name: "selfHelp",
        component: selfHelp,
      },
      {
        path: "/order",
        name: "order",
        component: order,
      },
      {
        path: "/invoice",
        name: "invoice",
        component: invoice,
      },
      {
        path: "/management",
        name: "management",
        component: management,
      },
      {
        path: "/agreement",
        name: "agreement",
        component: agreement,
      },
      {
        path: "/pay",
        name: "pay",
        component: pay,
      },
      {
        path: "/personalInfo",
        name: "personalInfo",
        component: () => import("../views/personalInfo.vue"),
      },
      {
        path: "/performance",
        name: "performance",
        component: () => import("../views/warrantyInsurance/performance.vue"),
      },
      {
        path: "/advancePayment",
        name: "advancePayment",
        component: () => import("../views/warrantyInsurance/advancePayment.vue"),
      },
      {
        path: "/wages",
        name: "wages",
        component: () => import("../views/warrantyInsurance/wages.vue"),
      },
    ],
  },
];
//如果为pc端则用pc端路由
var routes = [];
var browser = require("browser-tool");
if (browser().device == "PC") {
  routes = routespc;
} else if ( browser().device == "Mobile") {
  routes = routesm;
}
else {
  routes = routespc;
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// 路由守卫

router.beforeEach((to, from, next) => {

  //不登录就可以进入
  const whiteList = ['/headPay', '/newhomepage', '/mobilehome','/presentation']
  //如果进入到的路由是登录页,则正常展示
  if (to.path == "/login") {
    next();
  } else if (!(sessionStorage.getItem('userId'))&&whiteList.indexOf(to.path) == -1) {
    next("/login"); //转入login登录页面，登录成功后会将CAKey7存入sessionStorage
  } else {
    next(); // 以上全部满足 则什么都不做
  }
});
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

export default router;
